import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    jimak: { name: 'Jimak', noOfDays: 0, amount: 0, value: 0, perDay: 0 },
    nazar: { name: 'Nazar', noOfDays: 0, amount: 0, value: 0, perDay: 0 },
    custom: { name: 'Custom', noOfDays: 0, amount: 0, value: 0, perDay: 0 },
    totalAmount: 0
}

// helper function
const updateTotalAmount = (state) => {
    const total = parseFloat(state.jimak.amount) + parseFloat(state.nazar.amount) + parseFloat(state.custom.amount);
    state.totalAmount = parseFloat(total).toFixed(2);
};

const kaffarahSlice = createSlice({
    name: 'kaffarah',
    initialState: initialState,
    reducers: {
        reset: () => {
            return { ...initialState };
        },
        updateJimak: (state, action) => {
            state.jimak = { ...state.jimak, ...action.payload };
            state.custom = initialState.custom;
            updateTotalAmount(state);
        },
        updateNazar: (state, action) => {
            state.nazar = { ...state.nazar, ...action.payload };
            state.custom = initialState.custom;
            updateTotalAmount(state);
        },
        updateCustom: (state, action) => {
            state.custom = { ...state.custom, ...action.payload };
            state.jimak = initialState.jimak;
            state.nazar = initialState.nazar;
            updateTotalAmount(state);
        },
    }
})

export default kaffarahSlice.reducer;
export const kaffarahActions = kaffarahSlice.actions;